import { useContext } from "react";

import { UserContext } from "@/components/User";
import { usePageableQuery } from "@/core/queries";
import { fetchJobApplicationLifecycle } from "@/data/job-applications";

export const useJobApplicationLifecycleQuery = (jobApplicationId: number) => {
  const { contextCompany, contextConsultantProfileId } = useContext(UserContext);

  const result = usePageableQuery([contextConsultantProfileId, "job-application-lifecycle", jobApplicationId], params =>
    fetchJobApplicationLifecycle({
      ...params,
      companyId: contextCompany?.id,
      jobApplicationId,
    }),
  );

  return result;
};
